import React from "react";
import { Typography } from "@material-ui/core";

export default () => (
  <Typography variant="subtitle2">
    <p>© cover corp. All Rights Reserved.</p>
  </Typography>
);
